// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-picker .ant-picker-suffix{color:var(--date-picker-suffix-color)}.osui-picker.ant-picker-disabled{background:none;border-color:var(--theme-border-color-disabled)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
